import ko from 'knockout';
import _ from 'underscore';

export class BidLandscapeBaseViewModel {
  constructor({
    parentItem,
    i18n,
    inSimpleMode,
    entityType,
    dataToShow,
  }) {
    this.i18n = i18n;
    this.entityType = entityType;
    this.entityName = _.result(parentItem, 'EntityName', '');
    this.entityId = _.result(parentItem, 'Id', '');
    this.suggestedNewValue = ko.observable(_.result(parentItem, 'SuggestedNewValue', ''));
    this.currentValue = ko.observable(_.result(parentItem, 'CurrentValue', ''));
    this.dataArray = ko.observable([]);

    this.userInput = ko.observable('');
    this.valueToApply = ko.observable('');
    this.currentSelectedId = ko.observable(-1);
    this.currentSelectedId.subscribe(() => {
      this.selectedValueUpdated();
    });
    this.userInput.subscribe(() => {
      this.selectedValueUpdated();
    });

    this.landscapePointsLength = ko.pureComputed(() => _.size(this.dataArray()));
    this.currentSelectedId.extend({ notify: 'always' });
    this.valueToApply.extend({ notify: 'always' });
    this.invalidMsgByUser = ko.observable('');
    this.selectedValueUpdated = () => {
      this.inputErrorMessage('');
      if (this.currentSelectedId() === this.landscapePointsLength()) {
        const value = this.userInput();
        if (_.isEmpty(value) || !i18n.isValidDecimal(value, true)) {
          this.inputErrorMessage(i18n.getString('ErrorMessage_InputNumericValue'));
        } else if (i18n.parseDecimal(value) <= 0) {
          this.inputErrorMessage(i18n.getString('InputValueGreaterThanZero'));
        } else {
          this.valueToApply(this.userInput());
        }
      } else if (this.currentSelectedId() >= 0) {
        this.valueToApply(this.dataArray()[this.currentSelectedId()].bidStr);
      }
    };
    this.inputErrorMessage = ko.observable('');

    this.inputValid = ko.computed({
      read: () => this.inputErrorMessage() === '',
      write: _.noop,
    });

    this.bidlandscapeId = `${_.uniqueId()}_${this.entityId}`;
    this.hasData = ko.pureComputed(() => !_.isEmpty(this.dataArray()));

    this.startDateString = ko.observable('');
    this.endDateString = ko.observable('');
    this.inSimpleMode = ko.observable(inSimpleMode);
    this.isClickGraph = ko.observable(false);
    this.needCostColumn = ko.observable(false);

    this.footerText = ko.computed({
      read: () => i18n.getString('bidlandscapeHelpText').replace('{0}', '')
        .replace('{1}', '')
        .replace('{2}', `<b>${this.startDateString()}</b>`)
        .replace('{3}', `<b>${this.endDateString()}</b>`),
    });

    this.updatedSelectedIndex = (index) => {
      this.currentSelectedId(index);
      return true; // so that the action can spread to its radio
    };

    // Convert data for bidlanscape, default work on one set of data senario
    this.convertDataForBidLandscape = () => {
      if (!_.isEmpty(dataToShow) && !dataToShow.Nodata) {
        const data = this.convertDataForChart(dataToShow.ChartData, false);

        this.isClickGraph(data.showClick);
        this.dataArray(data.dataArray);
        this.currentSelectedId(data.selectedIndex);
        this.startDateString(dataToShow.ChartData.StartDateString);
        this.endDateString(dataToShow.ChartData.EndDateString);
      }
    };

    this.convertDataForChart = (data, hasZeroCurrentPoint) => {
      let landscapePoints = [];
      let selectedIndex = -1;
      let showClick = false;
      const currentBid = _.isNumber(this.currentValue()) ?
        this.currentValue() : i18n.parseDecimal(this.currentValue());
      const suggestedBid = _.isNumber(this.suggestedNewValue()) ?
        this.suggestedNewValue() : i18n.parseDecimal(this.suggestedNewValue());

      if (!_.isEmpty(data) && !_.isEmpty(data.BidLandscapePoints)) {
        // CurveType === 2 or CurveType === 16
        const hasClick = (data.CurveType & 18) > 0; // eslint-disable-line
        const bidlandscapePoints = data.BidLandscapePoints;

        landscapePoints = _.chain(bidlandscapePoints)
          .sortBy(point => -point.Bid)
          .uniq(point => point.Bid)
          .map((point, id) => {
            const result = {
              impressions: point.Impressions,
              impressionsStr: i18n.formatDecimalToInteger(point.Impressions),
              mlImpressions: point.MLImpressions,
              mlImpressionsStr: i18n.formatDecimalToInteger(point.MLImpressions),
              bid: point.Bid,
              bidStr: i18n.formatDecimalToFixed(point.Bid, 2),
              comment: '',
              index: id,
              clicks: point.Clicks || 0,
              clicksStr: i18n.formatDecimalToInteger(point.Clicks || 0),
              cost: point.Cost || 0,
              costStr: i18n.formatDecimalToFixed(point.Cost || 0, 2),
              view: point.View || 0,
              viewStr: i18n.formatDecimalToInteger(point.View || 0),
            };

            if (!hasZeroCurrentPoint && point.Bid === currentBid) {
              selectedIndex = selectedIndex < 0 ? id : selectedIndex;
              result.comment = ` (${i18n.getString('Current')})`;
            } else if (this.suggestedNewValue() > 0 && point.Bid === suggestedBid) {
              selectedIndex = id;
              result.comment = ` ${i18n.getString('Suggested')}`;
            }

            showClick = hasClick && point.Clicks > 0 ? true : showClick;
            return result;
          })
          .filter((point) => {
            // for adgroup bid landscape, bid 0 means current
            if (point.bid === 0 && hasZeroCurrentPoint) {
              this.customBidCurrentPoint(point);
              return false;
            }
            return true;
          })
          .value();

        selectedIndex = selectedIndex < 0 && !_.isEmpty(bidlandscapePoints) ? 0 : selectedIndex;
      }

      return {
        dataArray: landscapePoints,
        selectedIndex,
        showClick,
      };
    };
  }
}
